import graph from "./graph";
import { UnitModel } from "models";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { isEmptyObject } from "helpers/formatObject";
import { Button, CircularProgress } from "@mui/material";

export default function Units({ init = [], plan, refetch }) {
  const { id, lab_quantity, unit_quantity, doctor_quantity } = plan;
  const { userToken } = useSelector((state) => state.auth);
  const [create, { loading }] = useMutation(graph.create.query, {});

  const onSubmit = async (ids) => {
    try {
      const { data, errors } = await create({
        context: {
          serviceName: graph.create.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          unit_ids: ids,
          plan_id: id,
        },
      });
      if (!errors) {
        refetch();
        if (!isEmptyObject(data)) {
          const { messages } = data[graph.create.name];
          messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  const onAssign = (data, onClose) => {
    onClose();
    onSubmit(data.map((x) => x.id));
  };

  return (
    <>
      <UnitModel
        isPopup
        isAssign
        multiSelect
        title="انتخاب کلینیک"
        initFilter={{}}
        preSelected={init}
        onAssign={onAssign}
        action={
          <Button
            fullWidth
            size="large"
            color="primary"
            variant="contained"
            startIcon={
              loading && <CircularProgress color="primary" size={18} />
            }
          >
            انتخاب کلینیک
            {/* {unit_quantity} */}
          </Button>
        }
      />
    </>
  );
}
